import React, { Fragment } from "react";

import ButtonFields from "../button-fields/button-fields.component";

const AddEditButtons = ({
  isEdit,
  addButtons,
  handlers: { handleAdd, handleCancel, handleClear, handleSave },
  disableAdd,
}) => {
  return (
    <Fragment>
      {isEdit ? (
        <Fragment>
          <ButtonFields
            constants={addButtons.cancel}
            handler={handleCancel}
            disabled={false}
            min
          />
          <ButtonFields
            constants={addButtons.save}
            handler={handleSave}
            disabled={false}
            min
          />
        </Fragment>
      ) : (
        <Fragment>
          <ButtonFields
            constants={addButtons.clear}
            handler={handleClear}
            disabled={false}
            min
          />
          <ButtonFields
            constants={addButtons.add}
            handler={handleAdd}
            disabled={disableAdd}
            min
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default AddEditButtons;
